<template>
  <div class="awards_pay_bottom_pannel">
    <span class="confirm">{{str.confirm_submission}}</span>
    <strong class="total">{{total_to_pay_formatted}}</strong>
    <v-btn
      depressed
      color="success"
      class="submit"
      @click="$emit('submit')"
    >{{ total_to_pay > 0 ? str.pay_and_submit : str.submit }}</v-btn>
  </div>
</template>

<script>
import strings from '../strings/AwardsBottomPay'
export default {
  name: 'AwardsBottomPay',
  props: {
    total_to_pay: {
      type: Number,
      required: true
    }
  },
  computed: {
    str: function () {
      const lang = this.$store.state.user.language ? this.$store.state.user.language : 'en'
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][lang]
        }
      }, {})
    },
    total_to_pay_formatted: function () {
      if (this.$store.state.user['address']['country'].toLowerCase() === 'br') {
        return `R$ ${(this.total_to_pay / 100).toFixed(2).replace('.', ',')}`
      } else {
        return `U$ ${(this.total_to_pay / 100).toFixed(2)}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .awards_pay_bottom_pannel {
    position: fixed;
    bottom: 24px;
    left: calc(138px + ((100% - 542px)/2));
    transform: translateX(-50%);
    border: 4px dashed rgba(0,0,0,0.12);
    border-radius: 2px;
    padding: 6px 24px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fafafa;
    z-index: 39;
    .confirm {
      font-size: 18px;
      margin-right: 24px;
      color: rgba(0,0,0,0.54);
    }
    .total {
      font-family: 'Roboto Mono', monospace;
      font-size: 20px;
      margin-right: 12px;
      color: var(--success-color);
      font-weight: bold;
    }
  }
</style>
